// @ts-nocheck

import { createBrowserHistory, createHashHistory } from 'history';
import type { LocationShape, RouterHistory } from 'react-router-dom';

import { Target } from './client';
import { getLang } from './i18n/l10n';
import { LocalesBasename } from './types/common';

export type CustomRouterHistory = RouterHistory & {
  getPreviousPath: () => string | null;
  getPaths: () => Array<string>;
  goBackOrReplace: (location: string | LocationShape, state?: unknown) => void;
};

export type CustomRouterLocation = {
  hash: string;
  key: string;
  pathname: string;
  search: string;
  state?: { [key: string]: unknown };
};

const createHistory = () => {
  let history = null;
  // Use hash history for standalone env and tests. browser history otherwise
  if (Target.__STANDALONE__ || Target.__TEST__) {
    history = createHashHistory({
      basename: '', // The base URL of the app (see below)
      hashType: 'slash', // The hash type to use (see below)
    });
  } else {
    history = createBrowserHistory({
      basename: global.routerBasename || `/${LocalesBasename[getLang()]}`,
    });
  }

  let previousPath = null;
  let lastActionType = null;
  const paths = [];

  const updateHistoryLength = (location, action) => {
    lastActionType = action;

    switch (action) {
      case 'PUSH': {
        previousPath = paths.length ? paths[paths.length - 1] : null;

        if (previousPath !== location.pathname) {
          paths.push(location.pathname);
        }
        break;
      }

      case 'POP': {
        // goBack case
        if (paths.length > 0) {
          previousPath = paths.pop();
        }
        break;
      }

      default:
        break;
    }
  };

  history.listen(updateHistoryLength);

  history.getPreviousPath = () => previousPath;
  history.getLastActionType = () => lastActionType;
  history.getPaths = () => paths;
  history.getParentPath = () => paths[paths.length - 2] ?? null;

  history.goBackOrReplace = (location, state) => {
    if (paths.length) {
      history.goBack();
    } else {
      history.replace(location, state);
    }
  };

  return history;
};

export default createHistory;
